import { css } from '@emotion/react';
import { flex } from '@prototyp/gatsby-plugin-gumball/utils';

export const root = css`
  ${flex.display.flex};
  ${flex.justify.between};
  ${flex.align.center};
`;
